"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticsSearchClient = void 0;
const LogisticsClient_1 = require("./LogisticsClient");
class LogisticsSearchClient extends LogisticsClient_1.LogisticsClient {
    async search(options, params) {
        const rsp = await this.client.search(Object.assign({}, options), Object.assign({}, params));
        return rsp === null || rsp === void 0 ? void 0 : rsp.body;
    }
}
exports.LogisticsSearchClient = LogisticsSearchClient;
//# sourceMappingURL=LogisticsSearchClient.js.map